import { getTransit, postJson } from '../httpClient';

/**
 * Client for /api/org/:orgId/listings/* endpoints.
 *
 * These proxy through the server's Integration SDK so non-owner team
 * members (admin/manager/member) can read the org's listings — the
 * listings live on the owner's account but carry
 * `publicData.organizationId = orgId`, which the server filters by.
 *
 * Response shape mirrors what the Marketplace SDK returns (the data IS
 * Sharetribe data), so caller ducks can swap `sdk.ownListings.query` for
 * `orgListingsAPI.query` without changing render code.
 *
 * Spec: UPDATE.md §3.6.8.
 */
export const orgListingsAPI = {
  /**
   * GET /api/org/:orgId/listings
   * @param {string} orgId
   * @param {object} [params] — same filter/include params accepted by
   *   Marketplace SDK's listings.query (pub_type, states, include, ...).
   *   pub_organizationId is always forced server-side to `orgId`.
   */
  query: (orgId, params) => getTransit(`/api/org/${orgId}/listings`, params),

  /**
   * GET /api/org/:orgId/listings/:listingId
   */
  show: (orgId, listingId, params) =>
    getTransit(`/api/org/${orgId}/listings/${listingId}`, params),

  /**
   * POST /api/org/:orgId/listings/:listingId
   * Updates an org-owned listing via Integration SDK. Body shape is what
   * Marketplace SDK's `ownListings.update` accepts (publicData, title, …).
   * Requires EDIT_ANY_SHOW permission server-side.
   */
  update: (orgId, listingId, body) =>
    postJson(`/api/org/${orgId}/listings/${listingId}`, body),
};

